import ContentProduct from './ContentProduct'

export default ContentProduct
